import { useStyles } from '@webapps/styles';
import Header from 'pages/CFA/Convention/components/Header';
import TextEditor from 'pages/CFA/Convention/components/TextEditor';
import Footer from 'pages/CFA/Convention/components/Footer';
import Pagination from 'pages/CFA/Convention/components/Pagination';
import { useAuth, useToast } from '@webapps/reactjs-tech-components';
import { getPaginationNumbers } from 'pages/CFA/Convention/utils/pagination';
import { ADD_PAGE, EDIT_PAGE } from 'context/editor/editorActions';
import { Button } from '@material-ui/core';
import { useState } from 'react';
import { AddRounded } from '@material-ui/icons';

const ConventionContent = ({
    currentPageIndex,
    setEditorRef,
    dispatch,
    state,
    selectedDocument,
    setCurrentPageIndex,
    saveContentFunction,
    setSaveContentFunction,
    from,
    mode,
}) => {
    console.log("🚀 ~ selectedDocument:", selectedDocument)
    const {
        classes,
        theme: { spacing },
    } = useStyles(styles);

    const { addToast } = useToast();
    const { idUser } = useAuth();


    let thisDocumentFormState = {};
    if (from === "dashboard") {
        thisDocumentFormState = selectedDocument;
    } else {
        thisDocumentFormState = state?.documents.find(d => d?.id === selectedDocument?.id);
    }

    const pages = thisDocumentFormState?.pages || [];
    const paginationNumbers = getPaginationNumbers(currentPageIndex, pages.length, 7);

    const handleContentChange = (content) => {
        if (!pages[currentPageIndex - 1]) return;

        dispatch({ type: EDIT_PAGE, payload: { documentId: selectedDocument?.id, hasUnsavedChanges: true, page: { id: pages[currentPageIndex - 1]?.id, text: content } } });
    };

    const handleContentOverflow = () => {
        addToast({
            status: 'warning',
            message: 'Veuillez ajouter une nouvelle page.',
        });
    };





    return (
        <div className={classes.container}>
            <div className={classes.paperWrapper}>
                <div className={classes.paper}>
                    {currentPageIndex === 1 && <Header idUser={idUser} />}
                    {pages[currentPageIndex - 1] && (
                        <>
                            <TextEditor
                                content={pages[currentPageIndex - 1]?.content}
                                onChange={handleContentChange}
                                onContentOverflow={handleContentOverflow}
                                currentPageIndex={currentPageIndex}
                                isLastPage={currentPageIndex === pages.length}
                                setEditorRef={setEditorRef}
                                dispatch={dispatch}
                                state={state}
                                selectedDocument={selectedDocument}
                                from={from}
                            />
                        </>
                    )}
                    {currentPageIndex === pages.length && <Footer />}
                </div>
            </div>

            <Pagination
                currentPage={currentPageIndex}
                setCurrentPage={setCurrentPageIndex}
                totalPages={pages.length}
                paginationNumbers={paginationNumbers}
                style={{
                    justifyContent: "center",
                }}
            />
            {/* {
                from !== "dashboard" && <Button
                    className={classes.framerButton4}
                    onClick={handleAddPage}
                >
                    <AddRounded className={classes.framerIcon26} />
                    <span style={{ width: "max-content" }}>Ajouter une page </span>
                </Button>
            } */}
        </div>
    );
};

export const styles = ({ spacing, breakpoints }) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        gap: "24px",
        backgroundColor: '#f3f7ff',
        padding: '20px',
    },
    paperWrapper: {
        transformOrigin: 'top',
        [breakpoints.down(1480)]: {
            transform: 'scale(0.9)',

        },
        [breakpoints.down(1380)]: {
            transform: 'scale(0.8)',
        },
        [breakpoints.down(1255)]: {
            transform: 'none',
        },
        [breakpoints.down(1070)]: {
        }
    },
    paper: {
        alignContent: "center",
        borderRadius: "10px",
        width: '794px',
        minHeight: '1123px',
        height: '1123px',
        padding: '20px',
        backgroundColor: '#fff',
        transition: 'all 0.3s ease-in-out'
    },
    framerButton4: {

        border: "1px solid #c0d9ff",
        alignContent: "center",
        alignItems: "center",
        backgroundColor: "#f3f7ff",
        borderRadius: "40px",
        display: "block",
        flexDirection: "row",
        flexWrap: "nowrap",
        height: "40px",
        justifyContent: "space-between",
        padding: "5px 15px",
        width: "min-content",
        gap: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "span": {
            gap: "8px",
        },
        "&:hover": {
            borderColor: "#0060f9",
            "span": {
                color: "#0060f9",
            },
            "svg": {
                fill: "#0060f9",
            },
        },
    },
});

export default ConventionContent;